import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import SearchProvider from './components/SearchProvider.jsx'
import { ToastProvider } from './kit/Toast.jsx'
import './index.css'

window.addEventListener('error', (e) => {
  // eslint-disable-next-line no-console
  console.error('[window.error]', e.error || e.message, e.error?.stack)
})
window.addEventListener('unhandledrejection', (e) => {
  // eslint-disable-next-line no-console
  console.error('[unhandledrejection]', e.reason)
})

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <SearchProvider>
        {/* Kit toasts (decision #3: a short message after every save) — mounted once. */}
        <ToastProvider>
          <App />
        </ToastProvider>
      </SearchProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
